<template>
  <div v-if="dateRange" class="dark">

     <!-- Enhanced Card -->
     <div class="flex flex-col gap-y-3 lg:gap-y-5 p-6 md:p-8 bg-black/60 backdrop-blur-lg border border-white/20 rounded-3xl shadow-2xl transform transition-all duration-300 hover:scale-105">
      <div class="inline-flex justify-center items-center mb-2">
        <div class="w-3 h-3 inline-block bg-gradient-to-r from-red-400 to-red-600 rounded-full mr-3 animate-pulse"></div>
        <span class="text-xs font-semibold uppercase tracking-wider text-gray-300">Sends</span>
      </div>

      <div class="text-center">
        <div class="relative">
          <h3 class="text-6xl sm:text-7xl lg:text-8xl font-bold bg-gradient-to-r from-red-400 to-orange-500 bg-clip-text text-transparent gradient-text">
          {{ count }}
        </h3>
          <div class="absolute -top-2 -right-2 w-4 h-4 bg-red-400 rounded-full animate-bounce"></div>
        </div>
      </div>

      <div class="bg-black/40 backdrop-blur-md border border-white/10 rounded-xl p-4">
        <dl class="flex justify-center items-center divide-x divide-white/20">
          <dt class="pr-4">
            <span class="block text-sm font-semibold text-gray-300">{{ formatDate(dateRange.startDate) }}</span>
        </dt>
          <dd class="text-left pl-4">
            <span class="block text-sm font-semibold text-gray-300">{{ formatDate(dateRange.endDate) }}</span>
        </dd>
      </dl>
      </div>
    </div>
    <!-- End Card -->

  </div>
</template>

<script>
export default {
  name: 'welcome-total',
  props: {
    dateRange: {
        validator: function(value) {
            return typeof value === 'string' || typeof value === 'object';
        },
        required: true,
    },
    count: Number
},

  data() {
    return {
      // totalEntries: 0, // You may no longer need this since you're getting the count directly as a prop
    };
  },
  methods: {
    formatDate(inputDate) {
      // Parse the input date string
      const date = new Date(inputDate);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return 'Today';
      }

      // Extract day, month, and year
      const day = date.getDate().toString().padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      // Return the formatted date
      return `${month} ${day}, ${year}`;
    }
},
};
</script>

<style>
.vdp-datepicker input {
  font-size: 34px;
  font-weight: 900;
  text-align: center;
}
</style>
